import { useState, useEffect } from "react";
import "../styles/challenge-theme-category-creation.css";
import { useNavigate } from "react-router-dom";
import Button from "../../../../ui/atoms/buttons/Button";
import InputText from "../../../../ui/atoms/inputs/input-text/InputText";
import InputTextArea from "../../../../ui/atoms/inputs/input-textarea/InputTextArea";
import Select from "react-select";
//
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
//
import { ChallengeThemeSchema } from "../../../../core/utils/validators/challenge";
import { wait, isEmpty, capitalizeAll } from "../../../../core/utils/helpers";
import { onCreateChallengeTheme } from "../../services/challengeTheme";
import { onGetStreams } from "../../../admin/services/school";
//
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import useAxiosPrivate from "../../../../app/providers/context-provider/useAxiosPrivate";

const ChallengeThemeCreation = () => {
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const [isSending, setIsSending] = useState(false);

  const [streamsData, setStreamsData] = useState([]);
  const [selectedStreams, setSelectedStreams] = useState([]);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const signal = controller.signal;

    onGetStreams(axiosPrivate, signal).then((result) => {
      const _data = result?.data?.result || [];
      setStreamsData([]);
      if (!isEmpty(_data)) {
        for (let i = 0; i < _data.length; i++) {
          const element = _data[i];
          setStreamsData((prevState) => [
            ...prevState,
            {
              value: element?.classe_id,
              label: capitalizeAll(element?.classe_title),
            },
          ]);
        }
      }
    });

    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  }, []);

  const currentChallengeThemeCategory = useSelector(
    (state) => state?.challengeState?.currentChallengeThemeCategory,
  );

  const _current_challenge_theme_category_id =
    currentChallengeThemeCategory?.id;

  const _current_challenge_theme_category_title_en =
    currentChallengeThemeCategory?.title_en;
  const _current_challenge_theme_category_title_fr =
    currentChallengeThemeCategory?.title_fr;

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onTouched",
    resolver: yupResolver(ChallengeThemeSchema),
    defaultValues: {
      challenge_theme_category_id: _current_challenge_theme_category_id,
    },
  });

  useEffect(() => {
    setValue("related_streams", selectedStreams || []);
  }, [selectedStreams]);

  const onSubmit = async (data) => {
    if (isEmpty(selectedStreams)) {
      Swal.fire({
        title: "Challenge Theme linked Streams",
        text: "Please select the related streams for defined set of questions!",
        icon: "warning",
      });
      return;
    }
    //
    setIsSending(true);
    Swal.fire({
      title: "Creating new challenge theme...",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    await wait(700);
    //
    onCreateChallengeTheme(axiosPrivate, data)
      .then((response) => {
        const _data = response?.data;
        Swal.close();
        setIsSending(false);

        if (_data?.status) {
          Swal.fire({
            title: "Challenge Theme Creation",
            text: _data?.message,
            icon: "success",
            confirmButtonText: "OK",
            didOpen: () => {
              const btn = Swal.getConfirmButton(); //
              btn.style.backgroundColor = "#2840a8";
              btn.style.color = "white";
            },
          });
          reset();
          setSelectedStreams([]);
        } else {
          Swal.fire({
            title: "Challenge Theme Creation",
            text: _data?.message,
            icon: "info",
          });
        }
      })
      .catch((error) => {
        setIsSending(false);
        Swal.close();
        if (!error?.response) {
          Swal.fire({
            title: "Challenge Theme Creation",
            text: "No server response",
            icon: "warning",
          });
        } else {
          Swal.fire({
            title: "Challenge Theme Creation",
            text: error?.response?.data?.detail?.message,
            icon: "error",
          });
        }
      });
  };

  return (
    <form
      className="challenge-theme-category-creation"
      onSubmit={handleSubmit(onSubmit)}
    >
      <div className="c-t-c-cr-head">
        <button type="button" onClick={() => navigate(-1)}>
          ⬅️ Back to list
        </button>
        <div className="w-full d-flex justify-space-between align-center">
          <h1>🙎🏽 New Challenge Theme creation</h1>
          <Button
            type={isSending ? "button" : "submit"}
            preferedStyle={isSending ? "default" : "normal"}
            title={
              isSending
                ? "Creating new Challenge Theme..."
                : "Validate and Create new Challenge Theme"
            }
          />
        </div>
      </div>
      <div className="c-t-c-cr-body">
        <div className="w-full mb-lg">
          <h3 style={{ color: "grey" }}>
            Challenge Theme Category :{" "}
            {capitalizeAll(_current_challenge_theme_category_title_en)} /{" "}
            {capitalizeAll(_current_challenge_theme_category_title_fr)}
          </h3>
        </div>
        <div className="w-full d-flex gap-md mb-lg">
          <div className="w-50">
            <InputText
              type={"text"}
              name={"title_en"}
              title={"Title in English"}
              error={errors?.title_en?.message}
              register={register}
            />
          </div>
          <div className="w-50">
            <InputText
              type={"text"}
              name={"title_fr"}
              title={"Title in French"}
              error={errors?.title_fr?.message}
              register={register}
            />
          </div>
        </div>
        <div className="w-full d-flex gap-md mb-lg">
          <div className="w-50">
            <InputTextArea
              name={"description_en"}
              title={"Description in English"}
              error={errors?.description_en?.message}
              register={register}
            />
          </div>
          <div className="w-50">
            <InputTextArea
              name={"description_fr"}
              title={"Description in French"}
              error={errors?.description_fr?.message}
              register={register}
            />
          </div>
        </div>
        <div className="w-full">
          <Select
            value={selectedStreams}
            onChange={setSelectedStreams}
            options={streamsData}
            isMulti
            isSearchable
            placeholder={"Select related streams"}
            noOptionsMessage={() => "Oups! No more stream option."}
          />
        </div>
      </div>
    </form>
  );
};

export default ChallengeThemeCreation;
